import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { getQuestions } from 'src/apis/gameApi'
import { setGameCompleted } from 'src/ducks/game'
import GameCompletedPage from './GameCompletedPage'
import Question from './screens/Question'
import Result from './screens/Result'
import Start from './screens/Start'
import { GameMobileLayout, ScreenContainer } from './styles/mobile-styles'
import { Loader } from 'src/components/shared/Loader'
import usePageAccess, { PageEnum } from 'src/utils/usePageAccess'

export default function MobileGame() {
  const { currentUser } = useSelector((state) => state.auth)
  const { step, gameCompleted } = useSelector((state: any) => state.game)
  usePageAccess({ currentUser, page: PageEnum.Game, toastMsg: 'The game is currently closed' })

  const dispatch = useDispatch()

  const [isVisible, setIsVisible] = useState<boolean>(true)
  const [currentStep, setCurrentStep] = useState<number>(step)
  const [showResultForStep, setShowResultForStep] = useState<number | null>(null)
  const transitionDuration = 300

  const { data } = useQuery({
    queryKey: ['fetchQuestion'],
    queryFn: async () => {
      const response = await getQuestions()
      if (response.hasCompletedQuiz) {
        dispatch(setGameCompleted(true))
      }
      return response.questions
    },
  })

  useEffect(() => {
    if (step !== currentStep) {
      // Fade out
      setIsVisible(false)

      // After fade out completes, change screen and fade in
      const timeout = setTimeout(() => {
        setShowResultForStep(null)
        setCurrentStep(step)
        setIsVisible(true)
      }, transitionDuration) // Match the CSS transition duration

      return () => clearTimeout(timeout)
    }
  }, [step, currentStep, gameCompleted, transitionDuration])

  const handleQuestionSubmit = (step: number) => {
    setShowResultForStep(-1)
  }

  const handleResultComplete = () => {
    setShowResultForStep(null)
  }

  const renderScreen = () => {
    // Show result if we have a step to show result for
    if (showResultForStep !== null) {
      return <Result onComplete={handleResultComplete} transitionDuration={transitionDuration} />
    }

    if (gameCompleted) {
      return <GameCompletedPage />
    } else {
      switch (currentStep) {
        default:
        case 0:
          return <Start />
        case 1:
        case 5:
        case 8:
          return <Question maxAnswers={3} data={data[currentStep - 1]} onSubmit={handleQuestionSubmit} />
        case 2:
        case 3:
        case 4:
        case 7:
        case 11:
        case 13:
          return <Question maxAnswers={1} data={data[currentStep - 1]} onSubmit={handleQuestionSubmit} />
        case 6:
        case 9:
        case 10:
        case 12:
          return <Question maxAnswers={2} data={data[currentStep - 1]} onSubmit={handleQuestionSubmit} />
        case 14:
          return <GameCompletedPage />
        case -1:
          return <Result />
      }
    }
  }

  if (!data) {
    return <Loader loading />
  }

  return (
    <GameMobileLayout id="game-mobile-layout">
      <ScreenContainer isVisible={isVisible} id="screen-container">
        {renderScreen()}
      </ScreenContainer>
    </GameMobileLayout>
  )
}
